var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          ref: "planAdd",
          attrs: {
            "close-on-click-modal": false,
            title: "按司机批量添加班次",
            visible: _vm.visible,
            "destroy-on-close": "",
            "append-to-body": "",
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            close: function ($event) {
              return _vm.closeDialog()
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "planForm",
              attrs: {
                model: _vm.planForm,
                "label-width": "110px",
                "label-position": "left",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "价格方案：" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择价格方案" },
                      on: { change: _vm.handlePricemethod },
                      model: {
                        value: _vm.planForm.priceMethodId,
                        callback: function ($$v) {
                          _vm.$set(_vm.planForm, "priceMethodId", $$v)
                        },
                        expression: "planForm.priceMethodId",
                      },
                    },
                    _vm._l(_vm.priceMthodItems, function (item) {
                      return _c("el-option", {
                        key: item.priceMethodId,
                        attrs: {
                          label: item.priceMethodName,
                          value: item.priceMethodId,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "选择司机" } },
                [
                  _c("span", { staticStyle: { "margin-right": "10px" } }, [
                    _vm._v(
                      "\n          已选择" +
                        _vm._s(
                          _vm.driverList.length ? _vm.driverList.length : "0"
                        ) +
                        "个司机\n        "
                    ),
                  ]),
                  _c(
                    "el-button",
                    { attrs: { type: "text" }, on: { click: _vm.seleDriver } },
                    [
                      _c("span", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v("选择司机"),
                      ]),
                    ]
                  ),
                  _vm._l(_vm.driverList, function (obj, index) {
                    return _c(
                      "div",
                      { key: obj.driverId, staticClass: "plan-box" },
                      [
                        _c(
                          "el-tag",
                          {
                            staticClass: "plan-driver",
                            attrs: { closable: "" },
                            on: {
                              close: function ($event) {
                                return _vm.deleteDriver(index)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(obj.driverName) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._l(obj.timeList, function (time, i) {
                          return _c(
                            "el-tag",
                            {
                              key: i,
                              staticClass: "plan-time",
                              attrs: { closable: "", type: "info" },
                              on: {
                                close: function ($event) {
                                  return _vm.deleteTime(index, i)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " + _vm._s(time) + "\n          "
                              ),
                            ]
                          )
                        }),
                        _c("el-time-picker", {
                          staticClass: "time-picker",
                          attrs: {
                            "picker-options": {
                              selectableRange: "00:00:00 - 23:59:59",
                            },
                            "value-format": "HH:mm",
                            format: "HH:mm",
                            size: "mini",
                            placeholder: "选择时间",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.selectTime(index)
                            },
                          },
                          model: {
                            value: _vm.times[index],
                            callback: function ($$v) {
                              _vm.$set(_vm.times, index, $$v)
                            },
                            expression: "times[index]",
                          },
                        }),
                      ],
                      2
                    )
                  }),
                ],
                2
              ),
              _c("el-form-item", { attrs: { label: "站点设置" } }, [
                _c("span", { staticStyle: { "margin-right": "15px" } }, [
                  _vm._v(_vm._s(this.planForm.stationNameGroup)),
                ]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "标签" } },
                [
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        placement: "bottom",
                        width: "160",
                        trigger: "manual",
                      },
                      model: {
                        value: _vm.labelVisible,
                        callback: function ($$v) {
                          _vm.labelVisible = $$v
                        },
                        expression: "labelVisible",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            padding: "0px 0px 20px 20px",
                            "max-height": "200px",
                            "overflow-y": "scroll",
                          },
                        },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              attrs: { max: 2 },
                              model: {
                                value: _vm.labelCheck,
                                callback: function ($$v) {
                                  _vm.labelCheck = $$v
                                },
                                expression: "labelCheck",
                              },
                            },
                            _vm._l(_vm.labelList, function (item) {
                              return _c(
                                "div",
                                {
                                  key: item.label,
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    { attrs: { label: item.type } },
                                    [_vm._v(_vm._s(item.name))]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "has-permi",
                                          rawName: "v-has-permi",
                                          value: ["edit_label"],
                                          expression: "['edit_label']",
                                        },
                                      ],
                                      attrs: {
                                        size: "mini",
                                        type: "text",
                                        icon: "el-icon-edit",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleAdd(item, "edit")
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  编辑\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "flex flex-justify-between" }, [
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["add_label"],
                                    expression: "['add_label']",
                                  },
                                ],
                                attrs: { size: "mini", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleAdd({}, "add")
                                  },
                                },
                              },
                              [_vm._v("\n                添加\n              ")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "text" },
                                on: {
                                  click: function ($event) {
                                    _vm.labelVisible = false
                                  },
                                },
                              },
                              [_vm._v("取消")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.submitLabel()
                                  },
                                },
                              },
                              [_vm._v("确定")]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "el-button",
                        {
                          staticClass: "add-labels",
                          attrs: { slot: "reference", type: "text" },
                          on: { click: _vm.addLabels },
                          slot: "reference",
                        },
                        [_vm._v("\n            添加\n          ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    _vm._l(_vm.labels, function (item, index) {
                      return _c(
                        "el-tag",
                        {
                          key: index,
                          staticStyle: { "margin-right": "5px" },
                          attrs: {
                            closable: "",
                            type: "warning",
                            size: "small",
                          },
                          on: {
                            close: function ($event) {
                              return _vm.handleCloseLabel(index)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.labelList.filter(function (it) {
                                  return +it.id === item
                                })[0].name
                              ) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", size: "small" },
                      on: { click: _vm.closeDialog },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.submit()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.seleDriverShow
        ? _c("set-driver", {
            ref: "driverinfo",
            on: { DriverFormData: _vm.DriverFormData },
          })
        : _vm._e(),
      _c("AddLabel", {
        ref: "addLabel",
        on: {
          close: function ($event) {
            return _vm.$emit("addLabelClose")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }